import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';
import { useService } from 'shared/providers';
import { GetContractsForCustomerAndBrandProps } from 'shared/services/contract-service';

export function useExportContractInventory(props: GetContractsForCustomerAndBrandProps) {
  const { contractService } = useService();
  const { enqueueSnackbar } = useSnackbar();

  const mutation = useMutation<boolean, Error>(() => contractService.downloadContractInventory(props), {
    onSuccess: hasData => {
      if (!hasData) {
        enqueueSnackbar(`No contracts were found to export.`, {
          variant: 'warning',
        });
        return;
      }
      enqueueSnackbar(`Contracts have been exported`, {
        variant: 'success',
      });
    },
    onError: () => {
      enqueueSnackbar('There was a problem exporting contracts', { variant: 'error' });
    },
  });

  return mutation;
}
